import React, { useState, useEffect, useContext, useRef } from "react";
import useListenDataPersonalise from "../../hooks/useListenDataPersonalised";
import { eventViewPromotion, eventSelectPromotion } from "../../utilities/dataLayer";
import { Global } from "../../context/globalContextProvider";
import { empty } from "../../utilities/helper";

const AmountSelector = ({ selectorgroup, disabled = false, options: defaultOptions, tags }) => {
  const {
    // updateDonation, //removed by implementing the logic here using setDonationAmount
    // setPaymentMethod, //setPayments
    setShouldCoverDonationProcessingCost, // setChecked,
    donationAmount,
    setDonationAmount,
    // donationFrequency, //selectionTab
    // setDonationFrequency, //setSelectionTab
    // setContributor, //setContributer
    donationFixedProcessingCost,
    overwriteAskAmount,
  } = useContext(Global);

  const selectInputRef = useRef(null); //use to call selector
  const [selection, setSelection] = useState();
  const [options, setOptions] = useState(defaultOptions);

  useListenDataPersonalise(selectInputRef, setOptions, options);

  /**
   *
   * @param {string} selection
   */
  const onUpdateSelection = (selection, callBack = null) => {
    if (setDonationAmount) {
      if (donationFixedProcessingCost === 0) setShouldCoverDonationProcessingCost(false); // setChecked(false);
      eventSelectPromotion(selection);
      // console.log('selection', selection, options, donationFrequency, tags, defaultValue);
      const cleanedDonationAmount = selection
        // .replace(/\$/g, "") // remove dollar sign (This is not used as its sometimes the numbers got , within them)
        .replace(/[^0-9.]+/g, "") // remove all non-numeric characters
        .trim();
      setDonationAmount(cleanedDonationAmount); //updateDonation(selection);
    }
    setSelection(selection);

    if (typeof callBack === "function") callBack(selection);
  };

  //used to track something from dataLayer
  useEffect(() => {
    //original:
    // if (setDonationAmount !== null && !disabled) {
    //comment: not making sense to have the setDonationAmount as a function defined here, and the child not even using it.
    if (!disabled) {
      eventViewPromotion(options, tags[0]);
    }
    //  original:
    //    }, [disabled, tags, setDonationAmount]);
  }, [options, disabled, tags]);

  const isActive = (option) => {
    if (donationAmount) {
      return (
        Number(
          option
            // .replace(/\$/g, "") // remove dollar sign (This is not used as its sometimes the numbers got , within them)
            .replace(/[^0-9.]+/g, "") // remove all non-numeric characters
            .trim()
        ) === Number(donationAmount)
      ); //for amount-selector
    } else {
      return option === selection;
    }
  };

  return (
    <div
      className="selector"
      selectorgroup={selectorgroup ?? ""} //   selectorgroup={dataLayer ? dataLayer : ""}
      disabled={disabled}
      ref={selectInputRef}
      data-personalised="false"
    >
      {(!empty(overwriteAskAmount) ? overwriteAskAmount : options).map((option, index) => (
        <button
          type="button"
          className={`selector__button ${isActive(option) ? "active" : ""}`}
          onClick={() => onUpdateSelection(option)}
          key={`selector-button-${index}-${selectorgroup}`}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default AmountSelector;
